import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import VueAnalytics from 'vue-analytics';
import VueMeta from 'vue-meta'

Vue.use(ElementUI, { locale })
Vue.use(VueAnalytics, {
  id: 'G-8JRC76P086',
  router
})
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})


Vue.config.productionTip = false

// navigation guards before each
router.beforeEach((to, from, next) => {
		next()
    window.scroll(0, 0)	
})

axios.defaults.baseURL = 'https://notify.easytailorapp.com'
axios.defaults.headers.common = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

Vue.mixin({
	data() {
		return {
        master_server_url: 'https://api-lb.easytailorapp.com/',
      }
    }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js